<template>
  <div class="ba-card ba-w-100">
    <div class='ba-top'>
        <span class='ba-title'>{{ $t("ct-website-overview") }}</span>
        <div class='ba-box-items ba-flex ba-gp-1'>
            <select class='ba-select ba-md' v-model="page" @change="key++">
              <option value=''>{{ $t('ct-entire-website') }}</option>
              <option value='/'>/</option>
              <option :value='p.url' v-for="p in pageOptions">/{{ p.url }}</option>
          </select>
        </div>
    </div>

    <div class="ba-content ba-grid ba-gp-1">
      <overview :page="page" :key="key"></overview>
    </div>
  </div>
</template>

<script>
import Overview from '../pages/Overview.vue';
export default {
  name: "Analytics",
  components: {Overview},
  data() {
    return {
      page: '',
      key: 1
    }
  },
  computed: {
    pageOptions(){
      return (this.$parent.website.layouts[0].pages || [])
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Analytics.vue